import { PALETTE } from '../../../../theme/palette';

/**
 * Single product-page layout. (Templates are gone; this used to switch on one.)
 */
const TEMPLATE = {
  pageClass: 'bg-white',
  containerClass: '',
  gridClass: 'grid grid-cols-1 md:grid-cols-2 gap-8',
  mainPadding: 'pt-40 pb-16',
  styles: {
    '--product-text-color': PALETTE.text,
    '--product-muted-color': PALETTE.textSecondary,
    '--product-accent': PALETTE.orange,
  },
};

export const useProductPageTemplate = () => TEMPLATE;

export default useProductPageTemplate;
